import { render, staticRenderFns } from "./composeProcess.vue?vue&type=template&id=08636616&scoped=true&"
import script from "./composeProcess.vue?vue&type=script&lang=ts&"
export * from "./composeProcess.vue?vue&type=script&lang=ts&"
import style0 from "./composeProcess.scss?vue&type=style&index=0&id=08636616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08636616",
  null
  
)

export default component.exports